// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SS8GhNHcJXu7-kl4JtgpH","infoContainer":"TpUl8A4K_Beq8Vnp8EgPs","diffContainer":"_2w9c6WyqrOdXIwLQSvIyt1","diffValue":"_5_O8xXzsC1A9e8elMpQlK","controls":"y_nf7Xx0-l6kgCD9KXSdi","cancelBtn":"_1TkHJtzW-F7VZQ2mggEcNh","successBtn":"_2zWeX4ci-T6nWcHOZBcGaH","label":"_1pv2WZZIf3e3gxkVEKybZV","treeContainer":"_36FQJJS2Ll8kqEHI02Dt83","treeInnerContainer":"_2DslIqdzoulodFjlPbXq0t","savingLoaderContainer":"_2v9jeo6HcHn7xG196UJJ1"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupUnits/GroupUnits.pcss
// module id = 1383
// module chunks = 0